export default __webpack_public_path__ + "static/media/aleksandr.38f3bf85.jpg";